<dx-toolbar class="yo-toolbar p-mb-4">
  <dxi-item location="before">
    <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [width]="800"></yo-help>
    <yo-button
      label="CRÉER"
      tooltip="Créer un plan de production"
      [disabled]="!canCreatePlanProduction()"
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      (onClick)="openInitProcessus()">
    </yo-button>
  </dxi-item>
  <dxi-item location="after">
    <yo-button
      iconClass="fas fa-shipping-fast"
      [theme]="ButtonThemeEnum.DEFAULT"
      (onClick)="printLivraison()"
      [disabled]="isActionDisabled"
      tooltip="Générer le bon de livraison des plans de production sélectionnés">
    </yo-button>
  </dxi-item>
  <dxi-item location="after">
    <yo-button
      iconClass="fa fa-trash"
      [theme]="ButtonThemeEnum.DELETE"
      (onClick)="deletePlanProdItems()"
      [disabled]="isActionDisabled"
      tooltip="Supprimer les plans de production sélectionnés">
    </yo-button>
  </dxi-item>
</dx-toolbar>
<dx-data-grid
  [dataSource]="planProductionItems"
  [remoteOperations]="true"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(182)"
  width="100%"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [allowColumnResizing]="true"
  (onRowUpdated)="onRowUpdated($event)"
  (onSelectionChanged)="checkDisabledButtons()"
  columnResizingMode="widget"
  [noDataText]="noDataText"
  #grid>
  <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>
  <dxo-selection [deferred]="true" [allowSelectAll]="true" [showCheckBoxesMode]="checkBoxesMode"
                 mode="multiple"></dxo-selection>
  <dxi-column dataField="id" caption="Actions" [width]="showStepButton ? 250 : 90" cellTemplate="templateActions"
              [allowSorting]="false"
              alignement="left" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="site" caption="Site" cellTemplate="templateSite"
              [allowEditing]="false" alignement="left"></dxi-column>
  <dxi-column dataField="libelle" caption="Plan de production" [width]="'auto'" cellTemplate="templateLibelle"
              [allowEditing]="true"></dxi-column>
  <dxi-column dataField="date" caption="Date de création" cellTemplate="templateDate" [allowEditing]="false"
              alignment="left"></dxi-column>
  <dxi-column caption="Période de consommation" cellTemplate="periodeConsommationTemplate" [allowEditing]="false" alignment="left"></dxi-column>
  <dxi-column caption="Période de fabrication" cellTemplate="periodeFabricationTemplate" [allowEditing]="false" alignment="left"></dxi-column>
  <dxi-column dataField="code" caption="Code" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="currentStep" caption="Avancement" cellTemplate="templateAvancement" [allowSorting]="false"
              [allowEditing]="false" alignment="left"></dxi-column>
  <div *dxTemplate="let cell of 'templateActions'" class="custom-button-container">
    <yo-button iconClass="fas fa-edit"
               [theme]="ButtonThemeEnum.DEFAULT_INNER"
               tooltip="Visualiser le plan de production"
               (onClick)="editCurrentLine(cell.row.data.id)"
               [disabled]="!canEditProductionPlan(cell.row.data)">
    </yo-button>
    @if (showStepButton) {
      <dx-drop-down-button
        [splitButton]="false"
        [useSelectMode]="false"
        text="Accéder à une étape"
        keyExpr="id"
        displayExpr="label"
        [dropDownOptions]="{ width: 230 }"
        [items]="data"
        (onItemClick)="onClickStepForDirectAccess($event, cell.row.data.id, cell.row.data.currentStep)">
      </dx-drop-down-button>
    }
  </div>
  <div *dxTemplate="let cell of 'templateSite'">
    <td>
      <yo-site [siteId]="cell.row.data.site.id"></yo-site>
      {{cell.row.data.site.libelle}}
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateLibelle'">
    <strong>{{ cell.value }}</strong>
  </div>
  <div *dxTemplate="let cell of 'templateDate'">
    <td style="text-align: left;">
      {{ cell.row.data.dateCreation | date:'E d LLL yyyy' | titlecase }}
    </td>
  </div>
  <div *dxTemplate="let cell of 'periodeConsommationTemplate'">
    <td style="text-align: left;">
          {{ cell.row.data.dateDebutProduction | date:'dd/MM/yy' | titlecase }} - {{ cell.row.data.dateFinProduction | date:'dd/MM/yy' | titlecase }}
    </td>
  </div>
  <div *dxTemplate="let cell of 'periodeFabricationTemplate'">
    <td style="text-align: left;">
      @if (cell.row.data.dateDebutFabrication || cell.row.data.dateFinFabrication) {
        {{ cell.row.data.dateDebutFabrication | date:'dd/MM/yy' | titlecase }} - {{ cell.row.data.dateFinFabrication | date:'dd/MM/yy' | titlecase }}
      }
    </td>
  </div>
  <div *dxTemplate="let cell of 'templateAvancement'">
    <td (click)="openStep(cell.row.data.id)" [class.hover-background-grey]="cell.row.data.currentStep !== 'STEP_END'">
      <div>
        <i [class]="getClassFromCurrentStep(cell.row.data.id) + ' fas fa-square fa-lg mg-r-10'"></i>
        <label class="cursor">{{ getLabelFromCurrentStep(cell.row.data.id)  | uppercase }}</label>
      </div>
    </td>
  </div>

  <dxo-sorting mode="single"></dxo-sorting>
  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} plan(s) de production">
  </dxo-pager>

</dx-data-grid>

<yo-init-plan-de-production></yo-init-plan-de-production>

<yo-bon-livraison
  (loadingChange)="loadingVisible = $event.visible; loadingMessage = $event.message">
</yo-bon-livraison>

<yo-print-errors-bon-livraison></yo-print-errors-bon-livraison>
<yo-preparation-calcul-conditionnement-errors></yo-preparation-calcul-conditionnement-errors>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [message]="loadingMessage">
</dx-load-panel>
